module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Ia.b46dfec6.png";